<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/661lCN/tc-custom/9781460322697.jpg?1704717814994" alt="This image is the cover for the book Prince She Never Knew & Kholodov's Last Mistress, The Diomedi Heirs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prince She Never Knew & Kholodov's Last Mistress, The Diomedi Heirs
      </h1>
      <p class="bookDescription body article font2">
        <p>The Prince She Never Knew <br/><br/>Behind the royal wedding  <br/><br/>While the world believes her romance with Prince Leo Diomedi, Alyse knows it's just a calculated sham. <br/><br/>Yet beneath his icy exterior, Leo's kisses give Alyse a taste of the man behind the crown But will their fairy tale survive the headlines threatening to rip everything apart? <br/><br/>Kholodov's Last Mistress <br/><br/>An innocent in Moscow <br/><br/>Cold-hearted Sergei Kholodov was shocked by Hannah Pearl's wide-eyed approach to the world. Fearing her effect on him, Sergei obliterated all traces of her from his life. <br/><br/>One year later, he returns. Unable to escape her memory, could one more night allow him to forget her forever?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hewitt
      </h2>
      
      <p class="authorDescription body article">Kate Hewitt has worked a variety of different jobs, from drama teacher to editorial assistant to youth worker, but writing romance is the best one yet. She also writes women&#39;s fiction and all her stories celebrate the healing and redemptive power of love. Kate lives in a tiny village in the English Cotswolds with her husband, five children, and an overly affectionate Golden Retriever.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?492a11ce